var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModerator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2601",
    "data-name": "Group 2601",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.745,
    height: 10.129,
    viewBox: "0 0 14.745 10.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M128.158,13.3a1.587,1.587,0,0,1-.348-.68,1.4,1.4,0,1,1,2.707-.72,1.069,1.069,0,0,0,.065.229v.4a3.394,3.394,0,0,1-.142.422,1.417,1.417,0,0,1-.85.728l-.11.035a.4.4,0,0,0-.089.007,1.384,1.384,0,0,1-.56-.024A1.494,1.494,0,0,1,128.158,13.3Z",
    transform: "translate(-115.837 -9.846)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M83.884,26.673a1.494,1.494,0,0,0,.68.394,1.384,1.384,0,0,0,.56.024.41.41,0,0,0,.089-.007c-.064.492-.141.982-.248,1.466a7.7,7.7,0,0,1-.87,2.346.157.157,0,0,1-.023.027H78.93v-4.9a1.4,1.4,0,0,0,1-.419,1.88,1.88,0,0,0,.349.84,2.172,2.172,0,0,0,1.19.877,2.252,2.252,0,0,0,2.091-.358,2.1,2.1,0,0,0,.324-.295Z",
    transform: "translate(-71.563 -23.222)",
    fill: "#fcf286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M18.1,26.383v4.89H12.966a6.577,6.577,0,0,1-.708-1.659,11.469,11.469,0,0,1-.28-1.194c-.061-.326-.1-.653-.148-.984a.712.712,0,0,1,.093,0,1.426,1.426,0,0,0,.808-.117,2.055,2.055,0,0,0,.421-.293,2.2,2.2,0,0,0,1.027.653,2.254,2.254,0,0,0,2.252-.515A2.287,2.287,0,0,0,17.112,26a.118.118,0,0,1,.076.041,1.4,1.4,0,0,0,.9.338Z",
    transform: "translate(-10.727 -23.575)",
    fill: "#febf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M23.893,83h5.132v2.24a.151.151,0,0,0,.027.11c-.025.044-.061.031-.093.031H24.377c-.3,0-.486-.256-.487-.653C23.887,84.145,23.891,83.571,23.893,83Z",
    transform: "translate(-21.66 -75.254)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M78.906,85.44c-.031-.027-.027-.069-.027-.11V83.09h5.137v1.784c0,.327-.175.56-.416.568-.332.006-.666,0-1,0H79.013A.589.589,0,0,1,78.906,85.44Z",
    transform: "translate(-71.516 -75.336)",
    fill: "#fec030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M2.437,13.987a2.559,2.559,0,0,1-.431.3A1.426,1.426,0,0,1,1.2,14.4a.712.712,0,0,0-.093,0,1.944,1.944,0,0,1-.547-.262,1.406,1.406,0,0,1-.5-1.467,1.352,1.352,0,0,1,1.131-1.035,1.384,1.384,0,0,1,1.587,1.055,1.368,1.368,0,0,1-.28,1.223C2.474,13.94,2.458,13.965,2.437,13.987Z",
    transform: "translate(-0.011 -10.536)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M80,2.433a1.4,1.4,0,0,1-1,.419V.047A1.353,1.353,0,0,1,80.172.68,1.387,1.387,0,0,1,80.112,2.3C80.076,2.348,80.018,2.376,80,2.433Z",
    transform: "translate(-71.627 -0.045)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M65.3.026v2.8a1.4,1.4,0,0,1-.9-.338c-.022-.019-.042-.043-.076-.041a1.08,1.08,0,0,0-.147-.192,1.366,1.366,0,0,1-.271-.933A1.4,1.4,0,0,1,64.823.108,1.027,1.027,0,0,1,65.3.026Z",
    transform: "translate(-57.937 -0.023)",
    fill: "#faa741"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerator1);
export default __webpack_public_path__ + "static/media/moderator1.37e34f26a43d8507136273dc2c5b495c.svg";
export { ForwardRef as ReactComponent };